import { Controller } from '@hotwired/stimulus'

// Report-this-story dialog. Opens/closes the native <dialog> as a modal (so
// Esc-to-close and the inert backdrop come from the platform), and reveals the
// free-text reason field only when "Something else" is chosen — making it
// `required` then, and optional (and hidden) for every other category.
// Auto-registered by the controllers glob.
export default class extends Controller {
  static targets = ['dialog', 'reasonWrap', 'reason', 'reportableId']

  open() {
    const dialog = this.dialogTarget
    if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal()
  }

  // Open the shared comment dialog for a specific comment: stamp its id into the
  // hidden reportable_id field first. Bound to each comment's "Report" button via
  // data-report-reportable-id-param.
  openFor(event) {
    if (this.hasReportableIdTarget) this.reportableIdTarget.value = event.params.reportableId
    this.open()
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  // Bound to each category radio's `change`. The reason is required ONLY for the
  // "other" category; otherwise it is hidden and never blocks submission.
  toggleReason(event) {
    const isOther = event.target.value === 'other'
    if (!this.hasReasonWrapTarget) return

    this.reasonWrapTarget.hidden = !isOther
    if (this.hasReasonTarget) {
      this.reasonTarget.required = isOther
      if (isOther) this.reasonTarget.focus()
    }
  }
}
